let drawImageinfo = [
	// 	{
	// 	width: 100, //当前图片宽
	// 	height: 100, //当前图片高
	// 	posX: 10, //当前图片定位点x
	// 	posY: 10, //当前图片定位点Y
	// },
];

export function mergeImgs(list, cwith = 500, cheight = 500) {
	return new Promise((resolve, reject) => {
		const baseList = [];
		const canvas = document.createElement('canvas')
		canvas.width = cwith;
		canvas.height = cheight;
		const context = canvas.getContext('2d');
        let heightList = [] //放置高度的数组
		// context.fillStyle = '#777777'
		list.map((item, index) => {
			let img = new Image()
			img.src = item
			img.crossOrigin = 'Anonymous'
			img.onload = async () => {
				let imgInfo = await calculateImg(img, index, cwith, cheight,heightList)
				context.drawImage(imgInfo.img, imgInfo.posX, imgInfo.posY, imgInfo.width, imgInfo.height);
				const base64 = canvas.toDataURL('image/png')
				baseList.push(base64)
				if (baseList[list.length - 1]) {
					// 返回新的图片
					resolve(baseList[list.length - 1])
				}
			}
		})
	})
};
export function calculateImg(file, index, cwith, cheight,heightList) {
	let gap = 1; //图片之间的上下间隔
	let num = 2; //一行展示2张图片
	let ImgWidth = Math.floor((cwith - gap * num + 2) / num); //图片的宽度
	let ImgHeight = Math.floor((ImgWidth / file.width) * file.height)
	if (index < num) { //说明是第一行
		heightList.push(ImgHeight + 2)
		drawImageinfo[index] = {
			img: file, 
			width: ImgWidth,
			height: ImgHeight,
			posX: ImgWidth * index + gap * (index + 1),
			posY: gap
		}
	} else {
		let minItem = {
			minHeight: heightList[0],
			minIndex: 0,
		};
		for (let j = 0; j < heightList.length; j++) {
			if (heightList[j] < minItem["minHeight"]) {
				minItem["minHeight"] = heightList[j];
				minItem["minIndex"] = j;
			}
		}
		drawImageinfo[index] = { 
			img: file,
			width: ImgWidth,
			height: ImgHeight,
			posX: ImgWidth * minItem["minIndex"] + gap * (minItem["minIndex"] + 1),
			posY: minItem["minHeight"] + gap
		}
		heightList[minItem["minIndex"]] = minItem["minHeight"] + gap + ImgHeight;
	}

	// let randomW = '';
	// if(file.width > file.height){
	// 	randomW = getRandomIntInclusive(300, 450) // 图片横屏
	// }else{
	// 	randomW = getRandomIntInclusive(150, 300) // 随机图片宽度
	// }
	// let randomH = Math.floor((randomW / file.width) * file.height); //通过随机宽度计算等比例高度
	// file.width = randomW;
	// file.height = randomH;
	// if(index == 0){
	// 	drawImageinfo[index] = {
	// 		img:file,
	// 		width: randomW,
	// 		height: randomH,
	// 		posX: 10,
	// 		posY: 10
	// 	}
	// }else{
	// 	if( (cwith - drawImageinfo[index - 1].posX - drawImageinfo[index - 1].width - 10) > 150){
	// 		drawImageinfo[index] = {
	// 			img:file,
	// 			width: randomW,
	// 			height: randomH,
	// 			posX: drawImageinfo[index - 1].posX + drawImageinfo[index - 1].width + 10,
	// 			posY: drawImageinfo[index - 1].posY
	// 		}
	// 	}else{ 
	// 		//换行显示
	// 		console.log(100)



	// 		drawImageinfo[index] = {
	// 			img:file,
	// 			width: randomW,
	// 			height: randomH,
	// 			posX: 10, //当前图片定位点x
	// 			posY: 10, //当前图片定位点Y
	// 		}

	// 	}
	// }
	return drawImageinfo[index];
}

export function getRandomIntInclusive(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值 
}
